import styled from 'styled-components';
import { baseColors } from '@groupby/ui-components';
export const ModalOverlay = styled.div `
  position: fixed;
  inset: 0;
  z-index: 1400;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${({ theme }) => theme.spacing(2)};
`;
export const ModalContainer = styled.div `
  background-color: ${baseColors.white};
  border-radius: 8px;
  max-width: 560px;
  width: 100%;
  padding: ${({ theme }) => theme.spacing(4)};
  max-height: 80vh;
  overflow-y: auto;
`;
export const ModalTitle = styled.h2 `
  margin: 0 0 ${({ theme }) => theme.spacing(2)} 0;
  font-size: 1.25rem;
  font-weight: 600;
  color: ${baseColors.background900};
`;
export const ModalIntro = styled.p `
  margin: 0 0 ${({ theme }) => theme.spacing(3)} 0;
  font-size: 0.875rem;
  color: ${baseColors.background600};
  line-height: 1.5;
`;
export const SectionRow = styled.div `
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing(2)};
  padding: ${({ theme }) => theme.spacing(2)} 0;
  border-top: 1px solid ${baseColors.gray200};
`;
export const SectionText = styled.div `
  flex: 1;
`;
export const SectionTitle = styled.h4 `
  margin: 0 0 ${({ theme }) => theme.spacing(0.5)} 0;
  font-size: 0.875rem;
  font-weight: 600;
  color: ${baseColors.background900};
`;
export const SectionDescription = styled.p `
  margin: 0;
  font-size: 0.8125rem;
  color: ${baseColors.background600};
  line-height: 1.5;
`;
export const ModalFooter = styled.div `
  margin-top: ${({ theme }) => theme.spacing(3)};
  display: flex;
  justify-content: flex-end;
  gap: ${({ theme }) => theme.spacing(1.5)};
`;
